import React from "react";
import { DiCodeigniter } from "react-icons/di";
import * as reactIconsFA from "react-icons/fa";
import { FaFireAlt, FaLaptopCode } from "react-icons/fa";
import { GiGuitar } from "react-icons/gi";
import * as reactIconsIO from "react-icons/io";

export const statusCodes = ["O", "JIP", "JC", "PC"];

export const statusText = {
  O: "Open",
  JIP: "Job in Progress",
  JC: "Job Complete",
  PC: "Payment Complete"
};

const fontSize = 40;

export const ProjectColors = [
  "#FFF",
  "#eb7134",
  "#ddeb63",
  "#56a312",
  "#12a367",
  "#1584a3",
  "#424fff",
  "#5c2fbd",
  "#e53bf5"
];

export const projectIconsFA = Object.values(reactIconsFA).splice(30, 40);
export const projectIconsIO = Object.values(reactIconsIO).splice(1, 10);

export const projectIconsAll = projectIconsFA.concat(projectIconsIO);

export const projectIcons = [
  <FaLaptopCode fontSize={fontSize} />,
  <GiGuitar fontSize={fontSize} />,
  <FaFireAlt fontSize={fontSize} />,
  <DiCodeigniter fontSize={fontSize} />,
  <DiCodeigniter fontSize={fontSize} color={"red"} />,
  <DiCodeigniter fontSize={fontSize} color={"orange"} />,
  <DiCodeigniter fontSize={fontSize} color={"orange"} backgroundcolor={"red"} />
];
